import {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
  type ReactNode,
} from 'react';
import type {RESERVATION_SEARCH_METHOD} from '@chekin/core';

type LastMethod = {current: RESERVATION_SEARCH_METHOD | undefined};

const LastMethodContext = createContext<LastMethod | null>(null);

function MethodSwitchProvider({children}: {children: ReactNode}) {
  const lastMethod = useRef<RESERVATION_SEARCH_METHOD>();
  return (
    <LastMethodContext.Provider value={lastMethod}>{children}</LastMethodContext.Provider>
  );
}

function useMethodSwitch(
  method: RESERVATION_SEARCH_METHOD,
  methods: RESERVATION_SEARCH_METHOD[],
) {
  const lastMethod = useContext(LastMethodContext);
  const [from] = useState(() => lastMethod?.current);

  useEffect(() => {
    if (lastMethod) lastMethod.current = method;
  }, [lastMethod, method]);

  if (!from || from === method) return null;
  return methods.indexOf(method) > methods.indexOf(from) ? 'forward' : 'back';
}

export {MethodSwitchProvider, useMethodSwitch};
